import { useEffect, useState } from 'react';
import { fetchChatMediaUploads } from './api';

/**
 * Whether ant takes photos and video through its media bucket
 * (chatSupportStatus.mediaUploads). False until ant answers and whenever it
 * cannot: the composer then offers photos the legacy way and no video. Read
 * again for each conversation (`key`), so switching the bucket on or off in
 * ant reaches an open console without a reload; the last answer holds
 * meanwhile.
 */
export function useChatMediaUploads(key: string | null): boolean {
  const [on, setOn] = useState(false);

  useEffect(() => {
    let current = true;
    fetchChatMediaUploads().then((value) => {
      if (current) setOn(value);
    });
    return () => {
      current = false;
    };
  }, [key]);

  return on;
}
